import React from 'react';
import { FlexContainer, SkeletonBlock } from '../styles';

export const ServiceTitleSubtitle = (): JSX.Element => {
  return (
    <FlexContainer gap="21" isColumnDirection left={16}>
      <SkeletonBlock width="374" />
      <FlexContainer gap="58">
        <SkeletonBlock width="281" />
      </FlexContainer>
    </FlexContainer>
  );
};
